module.exports = __webpack_public_path__ + "static/media/recomendation-warning.2339ae3b.svg";